module.exports = __webpack_public_path__ + "static/media/07.c68d61ff.png";